import { RecordValidator, useGenericValidator } from '#record/validator';
import { RecordIssue } from '#submission/validator';
import isAfter from 'date-fns/isAfter';
import startOfDay from 'date-fns/startOfDay';
import { useT } from 'apprise-frontend-core/intl/language';
import { authorizationType } from './constants';
import { AuthorizationPatch } from './model';
import { detailsType } from '#details/constants';


export const useAuthorizationValidation = (): RecordValidator<AuthorizationPatch> => {

    const validator = useAuthorizationValidator()

    return useGenericValidator(authorizationType, validator)
}


export const useAuthorizationValidator = (): RecordValidator<AuthorizationPatch> => {

    const t = useT()

    return data => data.reduce((acc, { patch, current }) => {

        const issues: RecordIssue[] = []

        const { from, to } = patch[authorizationType]

        const dateFrom = startOfDay(new Date(from))
        const dateTo = startOfDay(new Date(to))

        if (!from)
            issues.push({ message: t('valid.missing_from_date'), type: 'error', location: 'from' })

        if (!to)
            issues.push({ message: t('valid.missing_to_date'), type: 'error', location: 'to' })


        if (from && to && isAfter(dateFrom,dateTo))
            issues.push({ message: t('valid.invalid_auth_range'), type: 'error', location: 'range' })

        if (to && isAfter(Date.now(), dateTo))
            issues.push({ message: t('valid.expired_auth_range'), type: 'warning', location: 'range' })

        // 09/2025: in "reflagging" scenarios, make sure the authorization dates don't overlap. 
        if (current && patch[detailsType] && patch[detailsType].flagstate && current[detailsType].flagstate !== patch[detailsType].flagstate) {

             const currentDateTo = startOfDay(new Date(current[authorizationType].to))

             if (isAfter(currentDateTo, dateFrom))
                issues.push({ message: t('valid.overlapping_auth_on_reflag'), type: 'error', location: 'range' })
        }

        return { ...acc, [patch.id]: issues }

    }, {})

}


